/** Friendly names for the backend's @TOKEN@ variables; the raw token is what gets saved. */
export const VARIABLE_LABELS: Record<string, string> = {
  '@CUSTOMER_NAME@': 'Customer name',
  '@ACCOUNT_ID@': 'Account number',
  '@CUSTOMER_EMAIL@': 'Customer email',
  '@COUNTY_NAME@': 'County name',
  '@USER_NAME@': 'Login email',
  '@LINK@': 'Account setup link',
};

/** Stand-ins for previews (kept in step with the backend's test-send samples). */
export const SAMPLE_VALUES: Record<string, string> = {
  '@CUSTOMER_NAME@': 'Sample Hotel LLC',
  '@ACCOUNT_ID@': '100001',
  '@CUSTOMER_EMAIL@': 'owner@example.com',
  '@COUNTY_NAME@': 'County',
  '@USER_NAME@': 'owner@example.com',
  '@LINK@': 'https://example.com/sample-link',
};

export const TOKEN_RE = /@[A-Z_]+@/g;

export function variableLabel(token: string): string {
  return VARIABLE_LABELS[token] ?? token.replace(/@/g, '').toLowerCase().replace(/_/g, ' ');
}

export function fillSample(text: string): string {
  return (text ?? '').replace(TOKEN_RE, t => SAMPLE_VALUES[t] ?? t);
}
